import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import imageLink from "./preset";
import { ConfigInterface } from "./types";
export default createWidget<ConfigInterface>({
  type: "opendash-widget-plotly-pivot",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "item",
    min: 1,
    //types: ["Number", "Boolean", "String"],
  },

  dataFetching: {
    history: true,
    historyRequired: true,
  },

  presets: [
    {
      label: "plotly:explorer.pivot.title",
      description: "plotly:explorer.pivot.description",
      layout: [6, 24],
      tags: ["pivot"],
      imageLink,

      widget: {
        config: {
          includeDateField: {
            minute: true,
            hour: true,
            day: true,
            week: true,
            dayOfWeek: true,
            month: true,
            year: true,
          },
        },
      },
    },
  ],
});
